import { render, staticRenderFns } from "./ChatNew.vue?vue&type=template&id=3fd996f7&scoped=true&"
import script from "./ChatNew.vue?vue&type=script&lang=js&"
export * from "./ChatNew.vue?vue&type=script&lang=js&"
import style0 from "./ChatNew.vue?vue&type=style&index=0&id=3fd996f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd996f7",
  null
  
)

export default component.exports